import { Spinner, Stack } from "@fluentui/react";
import React from "react";
import { FailureSeverity, MultipleFailureMessage, ValidationResult } from "sprint-common-web";

interface MoveOrderRequestToPendingValidationSummaryProps {
    validationResult: ValidationResult | undefined;
    isValidating?: boolean;
}

export const MoveOrderRequestToPendingValidationSummary: React.FC<MoveOrderRequestToPendingValidationSummaryProps> = ({
    validationResult,
    isValidating
}: MoveOrderRequestToPendingValidationSummaryProps) => {
    const failures = validationResult?.failures ?? [];

    return (
        <Stack
            styles={{
                root: { padding: 10 }
            }}
        >
            {isValidating && <Spinner />}
            {!isValidating && <MultipleFailureMessage failures={failures} severity={FailureSeverity.Error} />}
        </Stack>
    );
};
